import { Space, Tag } from 'antd'
import { FC } from 'react'
import { MaterialRequirement } from '../../../../../types/api/components/material/material-requirements'

interface TsAndLmProps {
    materialRequirements: MaterialRequirement[]
}

const TsAndLm: FC<TsAndLmProps> = ({ materialRequirements = [] }) => {
    const s = new Set<'ТС' | 'ЛМ'>()

    materialRequirements.forEach(x => {
        if (/тиснение/gi.test(x.material_type?.name || '')) {
            s.add('ТС')
        } else if (/ламинация/gi.test(x.material_type?.name || '')) {
            s.add('ЛМ')
        }
    })

    return (
        <Space size={2}>
            {[...s].map(x => (
                <Tag key={x} color={x === 'ТС' ? 'gold' : 'default'} bordered={false}>
                    {x}
                </Tag>
            ))}
        </Space>
    )
}

export default TsAndLm
